import styled from 'styled-components';

import { PRIMARY, GRAY } from 'constants/colors';

import { brightness } from 'utils/misc';

const WorkDayStyles = styled.div`
  width: 800px;
  border: 1px solid ${GRAY};
  padding: 10px;
  border-radius: 4px;
  position: relative;
  background-color: ${brightness(GRAY, 90)};
  min-height: 30px;

  & + .work-day {
    margin-top: 10px;
  }

  &.selected {
    border-color: ${PRIMARY};
    padding-bottom: 15px;
    background-color: ${brightness(PRIMARY, 85)};
  }

  .add-duty-btn {
    position: absolute;
    bottom: -2px;
    right: 14px;
  }

  .day-name {
    width: 85px;
  }

  .duties {
    flex-grow: 1;
  }

  .duty {
    & + .duty {
      margin-top: 15px;
    }

    .details {
      width: 300px;
      border-right: 2px solid ${PRIMARY};
      padding-right: 10px;
      margin-right: 10px;

      .time-info {
        white-space: nowrap;
        margin-right: 20px;
      }

      .header {
        font-family: 'signikasemibold';
        font-size: 16px;
      }
    }

    .periods {
    }

    .actions {
      flex-grow: 1;
    }
  }
`;

export default WorkDayStyles;
